import { FC } from "react";

import { EdtechAudioPlayer } from "@repo/edtech-audio-player";
import clsx from "clsx";

import st from "./Audio.module.scss";

type Props = {
  src: string,
  title: string,
  id: string,
  className?: string,
  isNeedDownload?: boolean,
};

export const Audio: FC<Props> = ({
  src,
  title,
  id,
  className,
  isNeedDownload = true,
}) => {
  return (
    <div className={clsx(st.container, className)}>
      <div className={st.audio}>
        <h3 className={st.title}>{title}</h3>

        <p className={st.description}>
          Мы ценим ваше мнение, поэтому для нас очень важно получать обратную
          связь. Так мы сможем улучшать наши материалы. После каждого урока вы
          сможете поставить оценку.
        </p>

        <EdtechAudioPlayer
          id={id}
          isNeedDownload={isNeedDownload}
          src={src}
          title={title}
        />
      </div>
    </div>
  );
};
